export type CreateNotificationResult = {
  title: string;
  message: string;
  type: 'success' | 'danger' | 'info';
};

export const resolveCreateNotification = async (
  response: any
): Promise<CreateNotificationResult> => {
  /** Case 1: already processed object */
  if (typeof response === 'object' && (response?.status || response?.message)) {
    const status = response.status === 'success' || response.ok === true;

    return {
      title: status ? 'Успешно' : 'Ошибка',
      message:
        response.message ||
        (status ? 'Операция выполнена успешно' : 'Произошла ошибка'),
      type: status ? 'success' : 'danger',
    };
  }

  /** Case 2: fetch Response */
  if (response && typeof response.json === 'function') {
    const status = response.ok;

    try {
      const resp = await response.json();

      if (!resp?.message) {
        return {
          title: 'Оповещение',
          message: 'Операция выполнена',
          type: status ? 'success' : 'info',
        };
      }

      return {
        title: status ? 'Успешно' : 'Ошибка',
        message: resp.message,
        type: status ? 'success' : 'danger',
      };
    } catch {
      return {
        title: response.ok ? 'Успешно' : 'Ошибка',
        message: response.ok
          ? 'Операция выполнена успешно'
          : `Ошибка: ${response.status}`,
        type: response.ok ? 'success' : 'danger',
      };
    }
  }

  /** Case 3: fallback / loading */
  return {
    title: 'Оповещение',
    message: 'Операция выполняется...',
    type: 'info',
  };
};
